import { ReactNode } from 'react';
import Accordion, { AccordionProps } from '../../../components/Accordion';
import Section from '../../../components/Section';
import Typography from '../../../components/Typography';
import styles from './Faq.module.scss';

interface FaqLabelProps {
  prefix: ReactNode;
  text: ReactNode;
}
function FaqLabel({ prefix, text }: FaqLabelProps) {
  return (
    <div className={styles.label}>
      <span>{prefix}: </span>
      <strong>{text}</strong>
    </div>
  );
}

const faq: AccordionProps<'h3'>['items'] = [
  {
    label: (
      <FaqLabel
        prefix="Question"
        text="How much does Inform cost? Is it really free?"
      />
    ),
    content: (
      <FaqLabel
        prefix="Answer"
        text="Inform is ABSOLUTELY free to use, now and always! Any one is able to sign up and generate automatic review responses."
      />
    ),
  },
  {
    label: <FaqLabel prefix="Question" text="How does Inform work?" />,
    content: (
      <FaqLabel
        prefix="Answer"
        text={
          <ul className={styles.list}>
            <li>
              All you have to do is sign-in with Google to register your account
              and you're ready to automate quick replies to your reviews!
            </li>
            <li>
              Whenever you select to reply to a review on our Reviews dashboard
              page, we will automatically generate a reply to it for you. You
              can customize your AI voice in the ‘AI Responses’ page, or even
              try out manual templated responses by writing a custom rule and
              human response to it.
            </li>
            <li>It's that easy!</li>
          </ul>
        }
      />
    ),
  },
  {
    label: <FaqLabel prefix="Question" text="How do I get started?" />,
    content: (
      <FaqLabel
        prefix="Answer"
        text={`You're already half-way there! Click the "Get Started" button above to register using your Google account, it takes only a second!`}
      />
    ),
  },
  {
    label: (
      <FaqLabel
        prefix="Question"
        text="What review platforms does Inform support?"
      />
    ),
    contentProps: {
      as: 'div',
    },
    content: (
      <FaqLabel
        prefix="Answer"
        text={
          <ul className={styles.list}>
            <li>
              For now, we only support generating review responses for Google
              Businesses- ie, your store, restaurant or business profile on
              Google Maps or Google Businesses!
            </li>
            <li>
              We're actively exploring adding support for Yelp, TripAdvisor,
              Facebook Reviews, and more platforms. Stay tuned!
            </li>
          </ul>
        }
      />
    ),
  },
];

function Faq() {
  return (
    <Section
      containerClassName={styles.container}
      className={styles.content}
      id="faq"
    >
      <Typography className={styles.heading} textType="h2">
        <span>Frequently</span>
        <span>Asked</span>
        <span>Questions</span>
      </Typography>
      <Accordion className={styles.items} labelAs="h3" items={faq} />
    </Section>
  );
}

Faq.routeProps = {
  path: 'faq',
  priority: 1,
  label: 'FAQ',
};
export default Faq;
